import { BREAKPOINTS } from '@/hooks/useBreakpoint'

/** Modal width: full bleed on mobile, capped on desktop */
export function modalWidth(desktop = 560): number | string {
  if (typeof window !== 'undefined' && window.innerWidth < BREAKPOINTS.md) {
    return 'calc(100vw - 2rem)'
  }
  return desktop
}

/** Drawer width: full on mobile, fixed on desktop */
export function drawerWidth(desktop = 480): number | string {
  if (typeof window !== 'undefined' && window.innerWidth < BREAKPOINTS.md) {
    return '100%'
  }
  return desktop
}
